'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _query = require('utilities/query');

var _adverseEvent = require('../adverse-event/adverse-event.service');

var _adverseEvent2 = _interopRequireDefault(_adverseEvent);

var _adverseEvents = require('./adverse-events.component');

var _adverseEvents2 = _interopRequireDefault(_adverseEvents);

var _adverseEventSearch = require('./adverse-event-search/adverse-event-search.module');

var _adverseEventSearch2 = _interopRequireDefault(_adverseEventSearch);

require('./adverse-events.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.adverseEvents', [_angularUiRouter2.default, _adverseEventSearch2.default]).component('adverseEvents', _adverseEvents2.default).service('AdverseEventService', _adverseEvent2.default).config(function ($stateProvider) {
  'ngInject';

  $stateProvider.state('adverseEvents', {
    parent: 'app',
    url: '/adverse-events',
    component: 'adverseEvents',
    params: {
      search: {
        value: 'default'
      }
    },
    resolve: {
      flex: function flex() {
        return '100';
      },
      layout: function layout() {
        return 'column';
      },
      query: function query() {
        return (0, _query.getQuery)();
      },
      limitOptions: function limitOptions() {
        return (0, _query.getLimitOptions)();
      },
      adverseEvents: function adverseEvents($stateParams, query, AdverseEventsService) {
        AdverseEventsService.setQuery(query);

        if (!$stateParams.search) {
          return AdverseEventsService.getAdverseEvents().then(function (r) {
            return r.data;
          });
        }

        if ($stateParams.search === 'status_open') {
          return AdverseEventsService.getAdverseEventsByStatus('OPEN').then(function (r) {
            return r.data;
          });
        }

        return AdverseEventsService.getAdverseEvents().then(function (r) {
          return r.data;
        });
      },
      alerts: function alerts(AdverseEventsService) {
        return AdverseEventsService.getAlerts().then(function (r) {
          return r.data;
        });
      },
      animalTypes: function animalTypes(AnimalTypeService) {
        return AnimalTypeService.getAnimalTypes().then(function (r) {
          return r.data;
        });
      },
      eventTypes: function eventTypes(AdverseEventsService) {
        return AdverseEventsService.getEventTypes();
      },
      searchCriteria: function searchCriteria($stateParams) {
        var selectedSearchType = 'All Adverse Events';
        if ($stateParams.search === 'status_open') {
          selectedSearchType = 'Open Adverse Events';
        }

        return {
          selectedSearchType: selectedSearchType
        };
      },
      searchTypes: function searchTypes(AdverseEventsService) {
        return AdverseEventsService.getSearchTypes();
      },
      sexes: function sexes(AdverseEventService) {
        return AdverseEventService.getAnimalSexes();
      },
      statuses: function statuses(AdverseEventService) {
        return AdverseEventService.getStatuses();
      },
      symptoms: function symptoms(AdverseEventService) {
        return AdverseEventService.getSymptoms();
      },
      occurrenceLikelihoods: function occurrenceLikelihoods(AdverseEventService) {
        return AdverseEventService.getOccurrenceLikelihoods();
      },
      injuryProbabilities: function injuryProbabilities(AdverseEventService) {
        return AdverseEventService.getInjurityProbabilities();
      },
      injurySeverities: function injurySeverities(AdverseEventService) {
        return AdverseEventService.getInjuritySeverities();
      }
    }
  });
}).name;


// WEBPACK FOOTER //
// ./components/app/adverse-events/adverse-events.module.js